import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a href="#application">
        <button className="px-6 py-3 bg-gradient-to-r from-[var(--dvx-primary)] to-[var(--dvx-primary-dark)] text-white font-oswald font-bold uppercase tracking-widest shadow-lg hover:scale-105 transition-transform flex items-center gap-2 text-sm">
          Apply Now <ArrowRight size={16} />
        </button>
      </a>
    </div>
  );
}
